import type { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@/meta/common";

const systemMangementRouter: RouteRecordRaw[] = [
    {
        path: "/systemMangement",
        name: "SystemMangement",
        component: () => import("@/layouts/index.vue"),
        meta: {
            title: "系统管理"
        },
        children: [
            {
                path: "systemManage",
                name: "SystemManage",
                meta: {
                    icon: "icon-a-Slice18",
                    title: "组织用户"
                },
                children: [
                    {
                        path: "organizationalStructure",
                        name: "OrganizationalStructure",
                        component: () =>
                            import("@/views/pages/manageCenter/systemManage/organizationalStructure/index.vue"),
                        meta: {
                            title: "组织架构",
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_ORG_R"
                                },
                                {
                                    label: "部门管理",
                                    value: "ROLE_DEPT_W"
                                },
                                {
                                    label: "员工管理",
                                    value: "ROLE_EMPLOYEE_W"
                                }
                            ],
                            activeMenu: "OrganizationalStructure"
                        }
                    },
                    {
                        path: "organizationalStructure/add",
                        name: "OrganizationalStructureAdd",
                        component: () =>
                            import("@/views/pages/manageCenter/systemManage/organizationalStructure/add/index.vue"),
                        meta: {
                            title: "新增员工",
                            hidden: true,
                            authOptions: [
                                {
                                    label: "员工管理",
                                    value: "ROLE_EMPLOYEE_W"
                                }
                            ],
                            activeMenu: "OrganizationalStructure"
                        }
                    },
                    {
                        path: "organizationalStructure/edit",
                        name: "OrganizationalStructureEdit",
                        component: () =>
                            import("@/views/pages/manageCenter/systemManage/organizationalStructure/add/index.vue"),
                        meta: {
                            title: "编辑员工",
                            hidden: true,
                            authOptions: [
                                {
                                    label: "员工管理",
                                    value: "ROLE_EMPLOYEE_W"
                                }
                            ],
                            activeMenu: "OrganizationalStructure"
                        }
                    },
                    {
                        path: "backendAccount",
                        name: "BackendAccount",
                        component: () => import("@/views/pages/manageCenter/systemManage/backendAccount/index.vue"),
                        meta: {
                            title: "后台用户",
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_USER_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_USER_W"
                                }
                            ],
                            activeMenu: "BackendAccount"
                        }
                    },
                    {
                        path: "backendAccount/add",
                        name: "BackendAccountAdd",
                        component: () => import("@/views/pages/manageCenter/systemManage/backendAccount/add/index.vue"),
                        meta: {
                            title: "新增后台用户",
                            hidden: true,
                            authOptions: [
                                {
                                    label: "管理",
                                    value: "ROLE_USER_W"
                                }
                            ],
                            activeMenu: "BackendAccount"
                        }
                    },
                    {
                        path: "backendAccount/edit",
                        name: "BackendAccountEdit",
                        component: () => import("@/views/pages/manageCenter/systemManage/backendAccount/add/index.vue"),
                        meta: {
                            title: "编辑后台用户",
                            hidden: true,
                            authOptions: [
                                {
                                    label: "管理",
                                    value: "ROLE_USER_W"
                                }
                            ],
                            activeMenu: "BackendAccount"
                        }
                    },
                    {
                        path: "role",
                        name: "Role",
                        component: () => import("@/views/pages/manageCenter/systemManage/role/index.vue"),
                        meta: {
                            title: "角色管理",
                            subTitle: [
                                "角色说明：角色是不同权限的集合，通过将角色分配给用户，实现系统在用户使用过程中基于角色的权限控制。"
                            ],
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_ROLE_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_ROLE_W"
                                }
                            ],
                            activeMenu: "Role"
                        }
                    },
                    {
                        path: "role/add",
                        name: "RoleAdd",
                        component: () => import("@/views/pages/manageCenter/systemManage/role/edit.vue"),
                        meta: {
                            title: "新增角色",
                            hidden: true,
                            pageType: PAGE_TYPE.DETAIL.code,
                            authOptions: [
                                {
                                    label: "管理",
                                    value: "ROLE_ROLE_W"
                                }
                            ],
                            activeMenu: "Role"
                        }
                    },
                    {
                        path: `role/detail`,
                        name: "RoleDetail",
                        component: () => import("@/views/pages/manageCenter/systemManage/role/detail.vue"),
                        meta: {
                            title: "角色详情",
                            hidden: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_ROLE_R"
                                }
                            ],
                            activeMenu: "Role"
                        }
                    },
                    {
                        path: `role/edit`,
                        name: "RoleEdit",
                        component: () => import("@/views/pages/manageCenter/systemManage/role/edit.vue"),
                        meta: {
                            title: "编辑角色",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            hidden: true,
                            authOptions: [
                                {
                                    label: "管理",
                                    value: "ROLE_ROLE_W"
                                }
                            ],
                            activeMenu: "Role"
                        }
                    }
                ]
            }
        ]
    }
];

export default systemMangementRouter;
